/* Tracking tab — extracted from FormBuilder.jsx (A7a) */
import React from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import TrackingConfig from '../TrackingConfig';

export default function TrackingTab({
  isMobile,
  formId,
  formName,
  trackingPixels,
  trackingVerification,
  setTrackingPixels,
  showToast,
}) {
  return (
          <div className={`fb-card${isMobile ? ' is-mobile' : ''}`}>
            <TrackingConfig
              formId={formId}
              formName={formName}
              trackingPixels={trackingPixels}
              trackingVerification={trackingVerification}
              onSave={async (updatedPixels) => {
                setTrackingPixels(updatedPixels);
                // Auto-save to Firestore
                if (formId && formId !== 'new') {
                  try {
                    await updateDoc(doc(db, 'forms', formId), {
                      trackingPixels: updatedPixels,
                      updatedAt: new Date(),
                    });
                  } catch (error) {
                    console.error('Error saving tracking pixels:', error);
                    showToast('Failed to save tracking configuration', 'error');
                  }
                }
              }}
            />
          </div>
  );
}
